<template>
  <div class="products-panel">
    <receipt-add-product
      v-if="showModal"
      :discount_each_line="discount_each_line"
      @sendProduct='sendProduct'
      @close="showModal=false"/>

    <div class="card products-card mb-1">
      <!-- HEADER: search bar + add button -->
      <div class="products-card__header">
        <div class="products-card__search">
          <receipt-products-search separator="*" :priceList='priceList'
            :product_default="product_default" :show-barcodes="showBarcodes" @productadded="incrementOrAdd"/>
        </div>
        <v-guard :permissions="['VER_AGREGAR_ETIQUETA']">
          <button type="button" class="btn btn-outline-primary products-card__add" @click="showModal = true">
            Agregar producto <i class="bi bi-plus-lg"></i>
          </button>
        </v-guard>
      </div>

      <!-- BODY: products table -->
      <div class="products-card__body">
        <table v-if="products.length > 0" class="table products-table table-striped">
          <thead>
            <tr>
              <th class="products-table__num">#</th>
              <th v-if="showBarcodes">Código</th>
              <th>Producto</th>
              <th v-if="showPrices" class="text-right">Precio unit.</th>
              <th class="text-center">Cantidad</th>
              <th v-if="discount_each_line && showPrices" class="text-center products-table__discount-col">Descuento</th>
              <th v-if="showPrices && disciva" class="text-center products-table__iva-col">% IVA</th>
              <th v-if="showPrices" class="text-right">Total</th>
              <th class="text-center products-table__actions">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(prod, index) in products.slice().reverse()" :key="prod.id + '-' + index">
              <td class="products-table__num">{{ products.length - index }}</td>
              <td v-if="showBarcodes">
                <div class="d-flex flex-column products-table__codes text-left">
                  <small v-if="prod.code" class="text-muted" title="Código interno">
                    <i class="bi bi-hash mr-1"></i>{{ prod.code }}
                  </small>
                  <small v-if="prod.barcode" class="text-muted" title="Código de barra">
                    <i class="bi bi-upc-scan mr-1"></i>{{ prod.barcode }}
                  </small>
                </div>
              </td>
              <td>
                {{prod.name}}
                <span v-if="prod.offer_price != null" class="badge badge-danger ml-1" title="Oferta aplicada">Oferta</span>
              </td>

              <!-- PRECIO UNITARIO -->
              <template v-if="showPrices">
                <template v-if="disciva">
                  <td v-if="allow_edit_price && prod.editable" class="text-right">
                    <div class="input-group input-group-sm products-table__price-edit">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input v-model.number="prod.gross" min="0" type="number" class="form-control text-right">
                    </div>
                  </td>
                  <td v-else class="text-right">{{formatoDinamicoMoneda(prod.gross)}}</td>
                </template>
                <template v-else>
                  <td v-if="allow_edit_price && prod.editable" class="text-right">
                    <div class="input-group input-group-sm products-table__price-edit">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input v-model.number="prod.price" min="0" type="number" class="form-control text-right">
                    </div>
                  </td>
                  <td v-else class="text-right">{{formatoDinamicoMoneda(prod.price)}}</td>
                </template>
              </template>

              <!-- CANTIDAD -->
              <td class="text-center">
                <div class="qty-stepper">
                  <button type="button" class="qty-stepper__btn" :disabled="prod.id==0 || prod.quantity <= 1" @click="decrementQty(prod)">−</button>
                  <input :disabled="prod.id==0" v-model.number="prod.quantity" @change="clampQty(prod)" min="1" type="number" class="qty-stepper__input">
                  <button type="button" class="qty-stepper__btn" :disabled="prod.id==0" @click="incrementQty(prod)">+</button>
                  
                </div>
              </td>

              <!-- DESCUENTO -->
              <td v-if="discount_each_line && showPrices" class="text-center">
                <div class="input-group input-group-sm products-table__discount-edit">
                  <input v-model.number="prod.discount" min="0" type="number" class="form-control text-right">
                  <div class="input-group-append">
                    <span class="input-group-text">{{ discount_each_line_type === 'amount' ? '$' : '%' }}</span>
                  </div>
                </div>
              </td>

              <!-- IVA -->
              <td v-if="showPrices && disciva" class="text-center products-table__iva">{{prod.taxtype}}%</td>

              <!-- TOTAL -->
              <td v-if="showPrices" class="text-right products-table__total">{{calcItemTotal(prod)}}</td>

              <!-- BTN BORRAR -->
              <td class="text-center">
                <button type="button" class="btn btn-outline-danger btn-sm products-table__delete" title="Borrar producto" @click="deleteproduct(index)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="products-card__empty">
          <i class="bi bi-box-seam"></i>
          <h5>Todav&iacute;a no hay productos</h5>
          <p class="text-muted small mb-0">Busc&aacute; con la lupa o ingres&aacute; el c&oacute;digo arriba.</p>
        </div>
      </div>

    </div>

    <!-- SUMMARY BAR -->
    <div v-if="products.length > 0" class="products-summary">
      <span class="products-summary__count">
        {{ productsCount }} {{ productsCount === 1 ? 'producto' : 'productos' }} <i class="bi bi-cart"></i>
      </span>
      <span class="products-summary__items">
        Items: <strong>{{ itemsCount }}</strong> <i class="bi bi-box"></i>
      </span>
      <div class="products-summary__right">
        <button type="button" class="btn btn-outline-danger btn-sm" @click="cleanAll()">
          <i class="bi bi-trash"></i> Vaciar todo
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import formatMoneyMixin from "../../../../mixins/formatMoneyMixin";
import receiptProductsSearch from './Receipt-products-search.vue';
import receiptAddProduct from './Receipt-addProduct.vue';

export default {
  props: [
    'showPrices',
    'config',
    'prexistprd',
    'showBarcodes',
    'keepItems',
    'product_default',
    'disciva',
    'allow_sale_without_stock',
    'allow_edit_price',
    'discount_each_line',
    'discount_each_line_type',
    'priceList',
    'productsAux',
    'storageKey'],
    mixins: [formatMoneyMixin],
  data: function() {
    return {
      prex: this.prexistprd,
      customlabel: false,
      products: JSON.parse(localStorage.getItem('products:' + (this.storageKey || 'pos'))) || [],
      showModal: false
    };
  },
  computed: {
    productsCount() {
      return this.products.length;
    },
    itemsCount() {
      return this.products.reduce((sum, p) => sum + (parseFloat(p.quantity) || 0), 0);
    },
    productsSubtotal() {
      return this.products.reduce((sum, p) => {
        const q = parseFloat(p.quantity) || 0;
        const price = this.disciva ? (parseFloat(p.gross) || 0) : (parseFloat(p.price) || 0);
        const discount = parseFloat(p.discount) || 0;
        let linetotal;
        if (this.discount_each_line_type === 'amount') {
          linetotal = q * (price - discount);
        } else {
          linetotal = q * (price - (discount * price / 100));
        }
        return sum + linetotal;
      }, 0);
    }
  },
  watch: {
    products: {
      handler: function() {
        for (var i = 0; i < this.products.length; i++) {
          if (typeof this.products[i].quantity == 'number' && this.products[i].id!=0) {
            if (this.products[i].quantity<0) this.products[i].quantity=0;
            this.products[i].quantity=(this.products[i].unit!='U') ? this.products[i].quantity : this.round(this.products[i].quantity,0);
            if ((this.products[i].quantity>this.products[i].stock) && (this.allow_sale_without_stock!=1)) {
              alert('Este producto tiene '+this.products[i].stock+((this.products[i].unit!='U') ? ' '+this.products[i].unit : ' unidades')+', no deberias vender mas de esta cantidad')
              this.products[i].quantity=this.products[i].stock;
            }
          }
          if(this.discount_each_line){
            if (typeof this.products[i].discount == 'number') {
              if(this.discount_each_line_type !== undefined && this.discount_each_line_type == 'amount'){
                if(this.products[i].discount>this.products[i].price) this.products[i].discount = this.products[i].price;
                if(this.products[i].discount<0) this.products[i].discount=0;
              } else {
                if(this.products[i].discount>100) this.products[i].discount = 100;//TODO que pasa si tengo que discriminar iva?
                if(this.products[i].discount<0) this.products[i].discount=0;
              }
            }
          }else{
            this.products[i].discount=0;
          }
        }
        this.$emit('productschanged', this.products);
      }, deep: true,
    },
    priceList(){
      let newProduct = [];
      let app=this;
      if(app.keepItems!=true){
        app.productsAux.forEach( element => {
          window.axios.get('/api/products/getProduct/'+element.id+'/'+app.priceList)
            .then(response => {
              response.data.data.quantity = element.quantity;
              response.data.data.price = parseFloat(response.data.data.price);
              newProduct.push(response.data.data);
          });
          app.products = newProduct;
        });
      }
    }
  },
  mounted: function () {
    this.customlabel = this.config.customlabel
    if (this.prex) {
      // Arranca desde los productos preexistentes (combo, presupuesto, etc.),
      // no desde lo que haya quedado en localStorage de un carrito anterior.
      this.products = this.prex.slice();
      this.prex=null;
      this.$emit('productschanged', this.products);
    }
  },
  methods: {
    deleteproduct: function(key) {
      this.products.splice(this.products.length - 1 - key, 1);
    },
    round: function(value, digits) {
        const factor = Math.pow(10, digits);
        return Math.ceil(value * factor) / factor;
    },
    sendProduct (product) {
      this.$emit('sendProduct', product);
      this.showModal = false;
    },
    incrementOrAdd: function(item) {
      item.bkprice = parseFloat(item.price);
      item.price = item.offer_price != null ? parseFloat(item.offer_price) : parseFloat(item.price);

      for (var i = 0; i < this.products.length; i++) { // Suma la cantidad nueva al producto

        if (this.products[i].id === item.id) {
          this.products[i].quantity = this.products[i].quantity + item.quantity;
          this.products[i].total = this.products[i].quantity * this.products[i].price;
          return;
        }

      }

      this.products.push(item);
    },
    incrementQty(prod) {
      prod.quantity = (parseFloat(prod.quantity) || 0) + 1;
    },
    decrementQty(prod) {
      prod.quantity = Math.max(1, (parseFloat(prod.quantity) || 1) - 1);
    },
    clampQty(prod) {
      const q = parseFloat(prod.quantity);
      if (isNaN(q) || q < 1) prod.quantity = 1;
    },
    cleanAll(){
      if(confirm("Esta seguro que desea borrar todos los productos?") == true){
        this.products=[];
      }
    },
    calcItemTotal(prod){
      let total = 0;
      if(this.disciva !== undefined && this.disciva == true)
      {
        if(this.discount_each_line_type == 'amount')
          total = this.formatoDinamicoMoneda(prod.quantity * (prod.gross - prod.discount));
        else
          total = this.formatoDinamicoMoneda(prod.quantity * (prod.gross - ((prod.discount*prod.gross)/100)));
      } else {
        if(this.discount_each_line_type == 'amount')
          total = this.formatoDinamicoMoneda(prod.quantity * (prod.price - prod.discount),2);
        else
          total = this.formatoDinamicoMoneda(prod.quantity * (prod.price - ((prod.discount*prod.price)/100)));
      }

      return total;
    }
  },
  components: {
    receiptProductsSearch,
    receiptAddProduct
  }

}

</script>
